import { render, staticRenderFns } from "./domainDetailsModal.vue?vue&type=template&id=39714cd0&"
import script from "./domainDetailsModal.vue?vue&type=script&lang=js&"
export * from "./domainDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports